import { cn } from '@/lib/utils';

function SkeletonList({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('border-grey-2 flex w-full flex-col items-start border-t-2', className)} {...props}>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="border-grey-2 flex h-[57px] w-full flex-col items-start border-b-2 bg-white p-0">
          <div className="flex h-[56px] w-full flex-col items-start gap-2 px-2 py-4">
            <div className="bg-grey-2 h-[16px] w-[200px] rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

export { SkeletonList };
